<template>
  <InputEle
    v-bind="{ modelValue, borderless, outlined, dense, error, errorMessage, label, placeholder, autofocus, multiple, separator }"
    icon="mdi-magnify"
    input-class="q-px-sm"
    separator
    :results="results"
    :loading="loading"
    :search="search"
    @update:model-value="onInput"
    @clicked-result="onClickedResult"
    @removed-result="onRemovedResult"
  >
    <template #prepend>
      <slot name="prepend" />
    </template>

    <template #selected-item="scope">
      <user-item
        :user="scope.item"
        clickable
        dense
        without-email
        @click="onResultClick(scope.item)"
      >
        <template v-if="showSelection" #default>
          <component
            :is="multiple ? 'q-checkbox' : 'q-radio'"
            :model-value="scope.selected"
            :val="true"
            dense
            class="no-pointer-events"
          />
        </template>
      </user-item>
    </template>
  </InputEle>
</template>

<script>
import searchMixin from './mixins/searchMixin'
import InputEle from 'components/partials/search/input/Input'
import inputMixin from 'components/partials/search/input/inputMixin'

export default {
  components: {
    InputEle
  },
  mixins: [searchMixin, inputMixin],
  methods: {
    search (val) {
      this.doSearch(val)
    }
  }
}
</script>
